import ENDPOINT from 'constants/endPoint';
import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

const complaintApi = {
  async getComplaints(payload = {}) {
    const params = getParamsFormObject(payload);
    const path = ENDPOINT.COMPLAINTS + params;

    const response = await axiosClient.get(path);
    return response.data;
  },

  async getComplaintDetail(id) {
    const path = ENDPOINT.COMPLAINT_DETAIL(id);

    const response = await axiosClient.get(path);
    return response.data;
  },

  async updateComplaint(id, data = {}) {
    const path = ENDPOINT.COMPLAINT_DETAIL(id);

    const response = await axiosClient.put(path, {
      status: data.status || 'RESOLVED',
      response: data.response || data.note || '',
      responseImages: data.responseImages || [],
    });
    return response.data;
  },

  async resolveComplaint(id, data = {}) {
    const path = ENDPOINT.COMPLAINT_DETAIL(id);

    const response = await axiosClient.put(path, {
      status: 'RESOLVED',
      response: data.response || data.note || '',
      responseImages: data.responseImages || [],
    });
    return response.data;
  },

  async rejectComplaint(id, data = {}) {
    const path = ENDPOINT.COMPLAINT_DETAIL(id);

    const response = await axiosClient.put(path, {
      status: 'SKIPPED',
      response: data.response || data.note || '',
      responseImages: data.responseImages || [],
    });
    return response.data;
  },
};

export default complaintApi;
